/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The SupplierTimeslotsInner model module.
 * @module model/SupplierTimeslotsInner
 * @version v1
 */
export class SupplierTimeslotsInner {
  /**
   * Constructs a new <code>SupplierTimeslotsInner</code>.
   * @alias module:model/SupplierTimeslotsInner
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>SupplierTimeslotsInner</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SupplierTimeslotsInner} obj Optional instance to populate.
   * @return {module:model/SupplierTimeslotsInner} The populated <code>SupplierTimeslotsInner</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SupplierTimeslotsInner();
      if (data.hasOwnProperty('value'))
        obj.value = ApiClient.convertToType(data['value'], 'String');
      if (data.hasOwnProperty('text'))
        obj.text = ApiClient.convertToType(data['text'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} value
 */
SupplierTimeslotsInner.prototype.value = undefined;

/**
 * @member {String} text
 */
SupplierTimeslotsInner.prototype.text = undefined;

